import React,{useState, useEffect} from 'react'
import db from '../firebase/config'
import sync from '../img/sync.png'
import { Icon, Dialog, Alert, Button } from '@blueprintjs/core';
import { getAuth} from "firebase/auth";
import { useAuthState } from 'react-firebase-hooks/auth';
import { getStorage, ref, getDownloadURL, uploadBytesResumable } from "firebase/storage";
import {setDoc, doc, collection, query,limit,onSnapshot,where, increment, updateDoc, deleteDoc} from 'firebase/firestore'
const uniqueId = require('react-unique-nums')
var moment = require('moment')
moment.utc().format();

const auth = getAuth()

function Voicestacks() {

    const [user] = useAuthState(auth)
    const [open, close] = useState(false)
    const [visible,setVisible]= useState(false)
    const [record,setRecord] = useState(false)
    const [duration,setDuration] = useState(0)
    const [audioURL, setAudioURL] = useState(null)
    const [alert,setAlert] = useState(false)
    const [initial,setInitial] = useState(30)
    const [allVoiceStack,setAllVoiceStack] = useState([])
    const [play,showPlay] = useState(false)
    const [uriToPlay,setUriToPlay] = useState(null)
    const [captions,setCaptions] = useState("")
    const [selected,setSelected] =useState('#30404D')
    const [caption,setCaption] = useState("")
    const [color,setColor] = useState("")
    const [owner,setOwner] = useState("")
    const [warnings,setWarnings] = useState(false)
    const [docId,setDocId] = useState("")

    const recordFn =()=>{
        if(duration === 0 && audioURL === null) {
            setDuration(0); setAudioURL(null);
            if(navigator.mediaDevices && navigator.mediaDevices.getUserMedia){
                navigator.mediaDevices.getUserMedia (
                    {audio:true}
                ).then(stream=>{
                    let chunks = [];
                    const options = {mimeType: 'audio/webm'};
                    const mediaRecorder = new MediaRecorder(stream, options);
                    mediaRecorder.start(); setRecord(true);

                        mediaRecorder.addEventListener('dataavailable',(e)=>{
                            if(e.data.size > 0) chunks.push(e.data)
                        })
                        
                         setTimeout(() => {
                             mediaRecorder.stop()
                         },30000);
    
                         var counter = setInterval(()=>{
                                setDuration(prev=>prev + 1)
                         } ,1000);
                         
                        mediaRecorder.addEventListener('stop',(e)=>{
                            clearInterval(counter);
                                setRecord(false);
                                const blob = new Blob (chunks, {type: 'audio/webm'})
                                const audioURL = window.URL.createObjectURL(blob);
                                    sendVoiceStack(blob)

                        })
                }).catch((error) => {console.error(error,'trying to record audio');})
            } else {
                console.log("your browser does not support recording audio")
            }
        } else {
            console.log("already recording")
            close(prev=>!prev)
        }
    }
    
    const sendVoiceStack=async(blob)=>{
        const voiceId = uniqueId();
        const timeStamp = moment.utc()
        const storage = getStorage();
        const docRef = doc(collection(db, "voices"))
        const storageRef = ref(storage, '/voice-stacks/'+user.email+'/'+voiceId);

         let Task = uploadBytesResumable(storageRef, blob);
                Task.on('state_changed',(snapshot)=>{
                    //const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                        //console.log(progress)
                        //setVisible(prev=>!prev); setAlert(prev=>!prev);
                },(error)=>{
                    console.error(error,'There was an error on uploading');
                }, ()=>{
                    getDownloadURL(Task.snapshot.ref).then((downloadURL) => {
                        //console.log('File available at', downloadURL);
                          setDoc(docRef,{
                              id:voiceId,
                              timeStamp:timeStamp._d,
                              owner:user.email,
                              owner_name:user.displayName,
                              owner_photo:user.photoURL,
                              voice_stacks:0,
                              voiceURL:downloadURL,
                              caption:captions,
                              color:selected,
                         });
                         deleteVoiceStack(); setCaptions("")
                      });
                })
    }

    const deleteVoiceStack =(e)=>{
        setDuration(0); setAudioURL(null);  setVisible(prev=>!prev)
    }

    useEffect(() => {
        const unSubscribe = async () => {
            const queryRef = query(
                 collection(db, "voices"),
                 limit(initial)
            );

            await onSnapshot(queryRef,(snapshot) =>{
                let resArry = []
                if(snapshot.empty) {console.log("empty snapshot")}
                snapshot.forEach(doc =>{
                 resArry.push({
                    id:doc.data().id,
                    voiceDocId:doc.id,
                    owner:doc.data().owner,
                    owner_name:doc.data().owner_name,
                    owner_photo:doc.data().owner_photo,
                    timeStamp:doc.data().timeStamp,
                    voiceURL:doc.data().voiceURL,
                    voice_stacks:doc.data().voice_stacks,
                    caption:doc.data().caption,
                    color:doc.data().color,
                    });
                })
                setAllVoiceStack(resArry)
            })

        }
        unSubscribe();
        return()=>unSubscribe();
    },[])

    const playFn =(uri,cap,hue, voiceDocId, owner)=>{
        setUriToPlay(uri); setCaption(cap); setColor(hue); setOwner(owner);
          setDocId(voiceDocId)
            showPlay(prev=>!prev)
             addListens( voiceDocId)

    }

    const stopRecordFn =()=>{
          close(prev=>!prev)
    }

    const addListens =async(voiceDocId)=>{
         //did i listened to it before
         const queryRef = query(
               collection(db, "listens"),
               where("voiceDocId","==",voiceDocId),
               where("listener","==",user.email),
         )
         await onSnapshot(queryRef,(snapshot) =>{
              if(snapshot.empty){
                  //havent listened to it so listen to it
                  const id = uniqueId()
                  const docRef = doc(collection(db, "listens"));
                   setDoc(docRef,{
                        id:id,
                        voiceDocId:voiceDocId,
                        listener:user.email,
                        listener_name:user.displayName,
                        listener_photo:user.photoURL
                   });

                   const updateRef = doc(db,"voices",voiceDocId);
                   updateDoc(updateRef,{
                      voice_stacks:increment(1)
                   })

              }
         });
         
    }

    const showListener =()=>{

    }

    const deleteVoiceStackFromDb=async()=>{
          let docRef = doc(db, "voices",docId)
          await deleteDoc(docRef)
          await setWarnings(prev=>!prev)
           await  showPlay(prev=>!prev)
    }
    return (
        <div style={{display: 'flex',}}>
            <div id="single-voice" onClick={()=>setVisible(prev=>!prev)}>
                <div id="voice-round" style={{borderColor:'#30404D'}}>
                    <img src={user.photoURL} alt="sync" />
                </div>
                <h3 style={{color: '#ecf1f5',textAlign: 'center'}}>New voice stack</h3>
                <div id="mic-btn">
                    <Icon icon="add"  color="#ecf1f5" style={{marginRight:10,marginLeft:80}}/>
                </div>

                
            </div>
             
             {allVoiceStack.length <= 0 ? <div /> 
                : <div style={{display: 'flex',overflow: 'auto'}}>
                    {allVoiceStack.map(item =>(
                                    <div key={item.id}id="single-voice" onClick={()=>playFn(item.voiceURL, item.caption, item.color, item.voiceDocId, item.owner)}>
                                    <div id="voice-round" style={{backgroundColor:item.color,borderColor:item.color}}>
                                        <p id="intent">{item.caption.substring(0,27)}..</p>
                                    </div>
                                    <h3 style={{color: '#ecf1f5',textAlign: 'center'}}>{item.owner_name}</h3>
                                    <div id="mic-btn">
                                        <Icon icon="volume-up"  color="#ecf1f5" style={{marginRight:10,marginLeft:42}}/>
                                          {item.voice_stacks <= 0 ? "": item.voice_stacks } Listens
                                    </div>
                    
                                    
                                </div>
                    ))}
                    </div>}
            <Dialog isOpen={visible} style={{backgroundColor:selected}}
                 onClose={()=>setVisible(prev=>!prev)} canOutsideClickCancel={true}>

                  <div id="just-bar" style={{marginTop:15}}>
                    <Icon icon="volume-up"  color="#ecf1f5" style={{margin:15}} size={40}/>
                        <p id="counter">0:{duration}</p>

            {captions === "" ? <div /> 
            
            : <button id="stop" style={{margin:15}} onClick={()=>{record ? stopRecordFn(): recordFn()}}>
                         <Icon icon="record"  color={record ? "#960C3F":"#0E86E0"}style={{marginLeft:-7,marginTop:-2}}  size={40}/>
                        </button>}
                  </div>
                 {audioURL === null ? <div/> 
                    : <div id="just-bar">
                        
                    <button id="stop-two"  style={{marginLeft:'10%',marginTop:7}} onClick={()=>deleteVoiceStack()}>    
                      <Icon icon="trash"  color={"#bbc6cf"}  size={24}/>
                      </button>

                        <audio controls style={{marginLeft:'3%',outline:'none'}}>
                            <source src={audioURL} type="audio/ogg"></source>
                        </audio>

                        <button id="stop-two" style={{margin:4}} onClick={()=>sendVoiceStack()}>
                         <Icon icon="send-message"  color={"#bbc6cf"}style={{marginLeft:10,marginTop:2}}  size={24}/>
                        </button>
                        </div>}
                
                <textarea type="text"  id="caption-area" 
                    placeholder="Write caption first before recording"
                    value={captions}
                    onChange={e=>setCaptions(e.target.value)} />
                    
                <div id="just-bar" style={{marginLeft:'2%'}}>

                    <div id="color-container" style={{backgroundColor:"#5C255C"}} onClick={()=>setSelected("#5C255C")}/>
                    <div id="color-container" style={{backgroundColor:"#1D7324"}} onClick={()=>setSelected("#1D7324")}/>
                    <div id="color-container" style={{backgroundColor:"#154360"}} onClick={()=>setSelected("#154360")}/>
                    <div id="color-container" style={{backgroundColor:"#F1C40F"}} onClick={()=>setSelected("#F1C40F")}/>
                    <div id="color-container" style={{backgroundColor:"#138D75"}} onClick={()=>setSelected("#138D75")}/>
                    <div id="color-container" style={{backgroundColor:"#273746"}} onClick={()=>setSelected("#273746")}/>
                    <div id="color-container" style={{backgroundColor:"#3498DB"}} onClick={()=>setSelected("#3498DB")}/>

</div>
            </Dialog>

            <Dialog isOpen={open} style={{backgroundColor:'#30404D'}}  onClose={()=>close(prev=>!prev)}>
                 <h3 id="h3"> Recording is still on progress</h3> 
                    </Dialog>

            <Alert  isOpen={alert} style={{backgroundColor:'#30404D'}} canOutsideClickCancel={true} onClose={()=>setAlert(prev=>!prev)}>
                <p id="p"> Voice stack uploaded successfully!</p>
                    </Alert>

                    
            <Alert  isOpen={warnings} style={{backgroundColor:'#30404D'}} canOutsideClickCancel={true} onClose={()=>setWarnings(prev=>!prev)}>
                <p id="p"> Voice stack deleted successfully! :(</p>
                    </Alert>



            <Dialog isOpen={play} style={{backgroundColor:color}} canOutsideClickCancel={true} onClose={()=>showPlay(prev=>!prev)}>
                <p id="caption-area">{caption}</p>
            <audio controls style={{marginLeft:'10%',width:'80%'}} autoPlay={true}>
                            <source src={uriToPlay} type="audio/ogg"></source>
                        </audio>
                        {owner === user.email ? <Button id="center" icon="trash" onClick={()=>deleteVoiceStackFromDb()}>Delete</Button>:<div/>}
                    </Dialog>

        </div>
    )
}

export default Voicestacks
